'use strict';

angular.module('cloudBillingLegacyFrontend').controller('AcCspAddStep03Ctrl', function ($scope, $state) {

  $scope.next = function() {

  };
});
